import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';

@Injectable({
  providedIn: 'root'
})
export class CardPeopleService {
  urlCardValidationPage: any;

  constructor(private http: HttpClient) {

    this.urlCardValidationPage = `${environment.bffBaseUrl}/pages/card-form-validate-people`;
  }

  ValidatePeople(type, ID, nationality, typeRequest): Observable<any> { // type 0 = new, 1= replacement
    let national = '';
    if (nationality !== '') {
      national = '&nationality=' + nationality;
    }
    const urlBuilder = this.urlCardValidationPage + '?documentType=' + type + national +
      '&documentNumber=' + ID + '&requestType=' + typeRequest;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  ValidatePeopleExcel(dataFormExcel): Observable<any> {
    const urlBuilder = this.urlCardValidationPage;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, dataFormExcel)
      : throwError(CustomsValidators.msgNotValidUrl);
  }


}
